module.exports = __webpack_public_path__ + "media/images/es/favicon-9236932e6b45e5a18527b9fc3b68f38d.png";